<template>
    <span :id="id" @click="toggle()"> 
        <i :class="{'w3-hide':tempshow,'w3-show':!tempshow}" class="fa fa-arrow-up"/>
        <i :class="{'w3-hide':!tempshow,'w3-show':tempshow}" class="fa fa-arrow-down"/>
    </span>  
</template>


<script>
  export default {
    
    props: {
        id: {
            type: String
        },    
        show: {
            type: Boolean,
            default:true
        }
  },  

     data: function() {
      return {
            tempshow:true//set a default
      };
    },
    methods:{
        toggle() {        
            this.tempshow = !this.tempshow
            this.$emit('change',this.tempshow)            
        }
    },
    created(){
        this.tempshow = this.show
        this.$emit('change',this.tempshow)    
    }
    
  };
</script>
 
  <style>


</style>



// WEBPACK FOOTER //
// src/components/shared/controls/OpenClose.vue